import React from "react";
import {
  Button, CircularProgress, Dialog, DialogActions, DialogContent, DialogTitle,
  List, ListItemButton, ListItemText, Stack, TextField, Typography,
} from "@mui/material";

export default function LinkDialog({
  open,
  candidateToLink,
  linkDialogSearchQuery,
  linkDialogSearchResults,
  linkDialogSearchLoading,
  onClose,
  onSearchQueryChange,
  onLinkCandidate,
}) {
  return (
    <Dialog open={open} onClose={onClose} fullWidth maxWidth="sm">
      <DialogTitle>既存の学名とリンク</DialogTitle>
      <DialogContent>
        <Stack spacing={2} sx={{ mt: 1 }}>
          <Typography>
            GBIFの学名: <strong>{candidateToLink?.gbif_records?.[0]?.scientificName || 'N/A'}</strong>
          </Typography>
          <Typography>
            を、データベース内の既存の学名に手動でリンクします。
          </Typography>
          <TextField
            label="データベース内の学名を検索"
            value={linkDialogSearchQuery}
            onChange={(e) => onSearchQueryChange?.(e.target.value)}
            fullWidth
            autoFocus
          />
          {linkDialogSearchLoading && <Stack alignItems="center"><CircularProgress size={24} /></Stack>}
          {linkDialogSearchResults.length > 0 && !linkDialogSearchLoading && (
            <List dense sx={{ maxHeight: 250, overflow: 'auto', border: '1px solid', borderColor: 'divider', borderRadius: 1 }}>
              {linkDialogSearchResults.map((name) => (
                <ListItemButton key={name.id} onClick={() => onLinkCandidate?.(name.id)}>
                  <ListItemText primary={name.name_spell_valid} secondary={`${name.current_rank} in ${name.parent?.name_spell_valid || 'N/A'}`} />
                </ListItemButton>
              ))}
            </List>
          )}
        </Stack>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>キャンセル</Button>
      </DialogActions>
    </Dialog>
  );
}
